import { PaymentAction } from '../types';

type ReturnType = Pick<
  PaymentAction,
  'paymentActionType' | 'paymentActionRequired' | 'paymentActionUrl'
> & {
  bannerMessage: string;
};

export const handlePaymentAction = (
  subscriptionMetadata: PaymentAction[],
): ReturnType => {
  // can't access property "find", e is undefined 
  const sequence = subscriptionMetadata?.find(
    (obj) => obj.application === 'sequence',
  );
  const leadFinder = subscriptionMetadata?.find(
    (obj) => obj.application === 'lead-finder',
  );
  const inboxAnalyzer = subscriptionMetadata?.find(
    (obj) => obj.application === 'inbox-analyzer',
  );
  const dialer = subscriptionMetadata?.find(
    (obj) => obj.application === 'dialer',
  );

  let bannerMessage = '';

  if (sequence?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one';
  } else if (leadFinder?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one_lead';
  } else if (inboxAnalyzer?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one_inbox';
  } else if (dialer?.paymentActionRequired) {
    bannerMessage = 'initial_payment_pending_text_one_dialer';
  }

  return {
    paymentActionRequired:
      sequence?.paymentActionRequired ||
      leadFinder?.paymentActionRequired ||
      inboxAnalyzer?.paymentActionRequired ||
      dialer?.paymentActionRequired,
    paymentActionType:
      sequence?.paymentActionType ||
      leadFinder?.paymentActionType ||
      inboxAnalyzer?.paymentActionType ||
      dialer?.paymentActionType,
    paymentActionUrl:
      sequence?.paymentActionUrl ||
      leadFinder?.paymentActionUrl ||
      inboxAnalyzer?.paymentActionUrl ||
      dialer?.paymentActionUrl,
    bannerMessage,
  };
};
